import { render, staticRenderFns } from "./UserRankSidebar.vue?vue&type=template&id=be9a384a"
import script from "./UserRankSidebar.vue?vue&type=script&lang=js"
export * from "./UserRankSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports